/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { getCaretMode } from "selectors/caretModeSelectors";
import { getTransformedCursorInfo } from "utils/CaretModeUtils";
import { getPageZoomLevel } from "selectors/zoom";
import { getCursorPageIndex, getIsCursorVisible, getCursorQuad } from "dc-preview-utils/src/selectors/cursorSelectors";

export const getCaretModeApis = stores => {
  function start() {
    stores.caretModeStore.setCaretMode(true);
  }

  function stop() {
    stores.caretModeStore.setCaretMode(false);
  }

  function getCaretInfo() {
    const caretInfo = {};
    caretInfo.isCaretVisible = getCaretMode(stores) && getIsCursorVisible(stores);
    if (caretInfo.isCaretVisible) {
      const pageIndex = getCursorPageIndex(stores);
      // Get the cursor quad in doc space coordinates
      caretInfo.caretQuads = getCursorQuad(stores);
      caretInfo.zoomLevel = getPageZoomLevel(stores, pageIndex);
      caretInfo.pageIndex = pageIndex;
    }
    return caretInfo;
  }

  return {
    caretMode: {
      start,
      stop,
      getCaretInfo
    }
  };
};
